const holds = (claims, permissionModule, level) => Boolean(claims?.includes(`Permission.${permissionModule}.${level}`));

/** A member of staff edits a section through their own role; a parent through their parent role. */
export const canEditSection = (user, profile, permissionModule) =>
    holds(user?.permissions, permissionModule, 'Edit') ||
    Boolean(profile?.isParentOfStudent && holds(user?.parentPermissions, permissionModule, 'Edit'));

export const canViewSection = (user, profile, permissionModule) =>
    canEditSection(user, profile, permissionModule) ||
    holds(user?.permissions, permissionModule, 'View') ||
    Boolean(profile?.isParentOfStudent && holds(user?.parentPermissions, permissionModule, 'View'));
